export default __webpack_public_path__ + "static/hasura-con-dark-8d922bc72d8f1c699d56849153560e7e.svg";